<template>
  <div class="container_wang_checkPending">
    <div class="inner_box">
      <div class="card">
        <p slot="title">
          资料信息审核中
        </p>
      </div>
      <p class="content">资料信息正在审核中，审核通过才能进行认证</p>
      <div style="display: flex;justify-content: center">
        <my-button @confirm="logout" style="margin-top: 140px">返回</my-button>
      </div>
    </div>
  </div>
</template>

<script>
  import MyButton from '@/components/MyButton'

  export default {
    name: "profileCheckPending",
    components: {
      MyButton
    },
    methods:{
      logout(){
        this.$router.this.$router.go(-1)
      }
    }

  }
</script>

<style scoped lang="less">

  .title {
    text-align: center;
    margin-top: 50px;
  }

  .inner_box {
    width: 866px;
    height: 546px;
    margin: 126px auto;
  }

  .card {
    width: 826px;
    font-size: 18px;
    height: 60px;
    line-height: 60px;
    margin-top:-90px;
    border-bottom: 1px solid rgba(234, 234, 234, 0.8);
  }

  .content {
    text-align: center;
    color: #525252;
    margin-top: 128px;
    font-size:20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myProfile/profileCheckPending.vue